var _defs, _path, _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconLanguageQLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .language-question-line {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.1px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "language-question-line",
    d: "M40.1,9.8C31.4,1.1,17.7,1.4,9.3,10.5c-7.4,8-7.4,20.4,0,28.8,6.7,7.4,17.1,9,25.4,4.7l2.1-1,6.7,1.9c1.5.3,1.3-.2,1.2-.9l-1.8-7,1.1-2.3c4-8,3.2-18.2-3.8-24.8h-.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "language-question-line",
    cx: 25,
    cy: 25,
    r: 10.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "language-question-line",
    x1: 27.2,
    y1: 27.2,
    x2: 35.3,
    y2: 35.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconLanguageQLine);
export default __webpack_public_path__ + "static/media/cloud_icon_language_q_line.253994f7c72dccc5526beb788e89e90e.svg";
export { ForwardRef as ReactComponent };